module.exports = __webpack_public_path__ + "img/66.9.TU.721627c8.png";